import React from 'react';
import { showAlert } from 'helper';
import Button from '../../../Button';
import Grid from '@mui/material/Grid';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import FormField from '../../../FormField';
import { useEffect, useState } from 'react';
import ApiInterface from "utils/ApiInterface";
import { useAuth0 } from '@auth0/auth0-react';
import TextButton from 'components/TextButton';

const Wrapper = styled.div`  
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #ffffff;
  flex-direction: column;

  button {
    font-family: Roboto;
    font-weight: 500;
    font-size: 13px !important;
    line-height: 15px !important;
    color: #707173 !important;

    &:hover {
      color: #de5e56 !important;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width:100%;
  margin: 0 auto 2rem;
`;

const Billing = () => {
  const { logout } = useAuth0();
  const profile = useSelector(state => state.profile.profile);
  const [newOrgInfo, setNewOrgInfo] = useState({
    display_name: "",
    AddressLine1: "",
    AddressLine2: "",
    City: "",
    Province: "",
    PostalCode: "",
    Country: ""
  })

  useEffect(() => {
    if (profile.organizations && profile.organizations[0]) {
      setNewOrgInfo({
        display_name: profile.organizations[0].display_name,
        AddressLine1: profile.organizations[0].metadata.AddressLine1,
        AddressLine2: profile.organizations[0].metadata.AddressLine2,
        City: profile.organizations[0].metadata.City,
        Province: profile.organizations[0].metadata.Province,
        PostalCode: profile.organizations[0].metadata.PostalCode,
        Country: profile.organizations[0].metadata.Country,
      })
    }
  }, [profile])

  async function deleteAccount() {
    const response = await ApiInterface.instance.deleteProfile();
    if (response.status === 200) {
      logout({ returnTo: window.location.origin })
    }
  }

  const updateOrgInfo = async () => {
    if (profile.organizations && profile.organizations[0]) {
      let response = await ApiInterface.instance.updateOrganization(profile.organizations[0].id, newOrgInfo);
      if (response && response.status === 200) {
        showAlert('success', 'Organization has been successfully updated!');
      }
    }
  }

  const hadleNameChange = (e) => {
    setNewOrgInfo({ ...newOrgInfo, display_name: e.target.value });
  }

  const handleAddressLine1Change = (e) => {
    setNewOrgInfo({ ...newOrgInfo, AddressLine1: e.target.value });
  }

  const handleAddressLine2Change = (e) => {
    setNewOrgInfo({ ...newOrgInfo, AddressLine2: e.target.value });
  }

  const handleCityChange = (e) => {
    setNewOrgInfo({ ...newOrgInfo, City: e.target.value });
  }

  const handleProvinceChange = (e) => {
    setNewOrgInfo({ ...newOrgInfo, Province: e.target.value });
  }

  const handlePostalCodeChange = (e) => {
    setNewOrgInfo({ ...newOrgInfo, PostalCode: e.target.value });
  }

  const handleCountryChange = (e) => {
    setNewOrgInfo({ ...newOrgInfo, Country: e.target.value });
  }

  return (
    <>
      <FormField label="Company" id="company">
        <input id="company" type="text" placeholder="Enter Company Name" value={newOrgInfo.display_name} onChange={hadleNameChange} />
      </FormField>
      <FormField label="Address Line 1" id="address-1">
        <input id="address-1" type="text" placeholder="Enter Address Line 1" value={newOrgInfo.AddressLine1} onChange={handleAddressLine1Change} />
      </FormField>
      <FormField label="Address Line 2" id="address-2">
        <input id="address-2" type="text" value={newOrgInfo.AddressLine2} onChange={handleAddressLine2Change} />
      </FormField>
      <Grid container spacing={1} >
        <Grid item xs={6}>
          <FormField label="City" id="city">
            <input id="city" type="text" placeholder="Enter City" value={newOrgInfo.City} onChange={handleCityChange} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField label="Province" id="province">
            <input id="province" type="text" placeholder="Enter Province" value={newOrgInfo.Province} onChange={handleProvinceChange} />
          </FormField>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <FormField label="Postal Code" id="postal-code">
            <input id="postal-code" type="text" placeholder="Enter Postal Code" value={newOrgInfo.PostalCode} onChange={handlePostalCodeChange} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField label="Country" id="country">
            <input id="country" type="text" placeholder="Enter Country" value={newOrgInfo.Country} onChange={handleCountryChange} />
          </FormField>
        </Grid>
      </Grid>
      <Content>
        <Button onClick={updateOrgInfo} style={{ width: '80%', height: '30px' }}>Save Changes</Button>
      </Content>
      <Wrapper>
        <TextButton onClick={deleteAccount} text="Delete Account" style={{ width: '80%', height: '30px' }}/>
      </Wrapper>
    </>
  );
}

export default Billing;